import { dangerColor, defaultFont, successColor } from 'assets/jss/material-dashboard-pro-react';

const customInputStyle = theme => ({
  disabled: {
    '&:before': {
      borderColor: 'transparent !important',
    },
  },
  underline: {
    '&:hover:not($disabled):before,&:before': {
      borderColor: '#D2D2D2 !important',
      borderWidth: '1px !important',
    },
    '&:after': {
      borderColor: theme.palette.primary.main,
    },
  },
  underlineError: {
    '&:after': {
      borderColor: dangerColor,
    },
  },
  underlineSuccess: {
    '&:after': {
      borderColor: successColor,
    },
  },
  labelRoot: {
    ...defaultFont,
    color           : '#AAAAAA !important',
    fontWeight      : '400',
    fontSize        : '14px',
    lineHeight      : '1.42857',
    top             : '10px',
    '& + $underline': {
      marginTop: '0px',
    },
  },
  labelRootError: {
    color: `${dangerColor} !important`,
  },
  labelRootSuccess: {
    color: `${successColor} !important`,
  },
  formControl: {
    margin                                               : ({ inherit }) => (inherit ? '0' : '0 0 17px 0'),
    paddingTop                                           : '27px',
    position                                             : 'relative',
    verticalAlign                                        : 'unset',
    '& svg,& .fab,& .far,& .fal,& .fas,& .material-icons': {
      color: '#495057',
    },
  },
  whiteUnderline: {
    '&:hover:not($disabled):before,&:before': {
      backgroundColor: '#FFFFFF',
    },
    '&:after': {
      backgroundColor: '#FFFFFF',
    },
  },
  input: {
    color       : '#495057',
    '&$disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
    },
    '&,&::placeholder': {
      fontSize  : '14px',
      fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
      fontWeight: '400',
      lineHeight: '1.42857',
      opacity   : '1',
    },
    '&::placeholder': {
      color: '#AAAAAA',
    },
  },
  whiteInput: {
    '&,&::placeholder': {
      color  : '#FFFFFF',
      opacity: '1',
    },
  },

});

export default customInputStyle;
